export const USER_ROLES = {
  ADMIN: 'Admin',
  MEMBER: 'Member',
  VIEWER: 'Viewer',
  APPROVER: 'Approver'
};

export const getUserAccessBasedOnRole = role => {
  switch (role) {
    case USER_ROLES.ADMIN:
      return 'Full';
    case USER_ROLES.MEMBER:
      return 'Restricted';
    case USER_ROLES.VIEWER:
      return 'View-only';
    default:
      return 'Approve-only';
  }
};
